// 리전 컨텍스트 정의
import type { RegionInfo, SupportedRegionCode } from '../services/regionDetector';

import { createContext } from 'react';

export interface RegionContextValue {
  regionInfo: RegionInfo | null;
  isLoading: boolean;
  isOverseas: boolean;
  setTestRegion: (countryCode: SupportedRegionCode) => void;
  clearTestRegion: () => void;
  clearCache: () => void;
  refreshRegion: () => Promise<void>;
}

export const RegionContext = createContext<RegionContextValue | undefined>(undefined);
